import { render, staticRenderFns } from "./GameServerCard.vue?vue&type=template&id=2ef81e23&scoped=true"
import script from "./GameServerCard.vue?vue&type=script&lang=js"
export * from "./GameServerCard.vue?vue&type=script&lang=js"
import style0 from "./GameServerCard.vue?vue&type=style&index=0&id=2ef81e23&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ef81e23",
  null
  
)

export default component.exports